<template>
  <div
    v-if="painless"
    class="mb-5"
  >
    <div class="title-row mb-3">
      <h2 class="section-header">
        {{ title }}
      </h2>
      
      <v-spacer />
      
      <slot name="actions" />
    </div>
    <slot />
  </div>

  <v-card
    v-else
    flat
    class="mb-3"
  >
    <v-card-title>
      <h3 class="title font-weight-light">
        {{ title }}
      </h3>
      <v-spacer />
      <slot name="actions" />
    </v-card-title>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ContentSection',
  props: {
    title: {
      type: String,
      default: ''
    },
    // New prop to toggle between Card and Clean layouts
    painless: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped>
/* We renamed this to .title-row so it doesn't conflict 
   with Vuetify's built-in .title class 
*/
.title-row {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
  display: flex; /* Makes the v-spacer work */
  align-items: center;
}

.section-header {
  font-weight: 300; /* Matching the 'font-weight-light' look */
}

/* Ensure consistent spacing inside the card */
.v-card__text {
  padding-top: 16px; 
}
</style>